import styled from 'styled-components';
import FormTextField from './FormTextField';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ReportVisible = styled.div`
  color: rgb(0, 159, 15);
  font-size: 0.75rem;
  line-height: 1em;
  font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
`;

const FormHighlightedTextField = props => {
  return (
    <Wrapper>
      <FormTextField {...props} />
      {props.input.value && (
        <ReportVisible>{`Visible in admin report: ${props.input.value.slice(0, 40)}`}</ReportVisible>
      )}
    </Wrapper>
  );
};

export default FormHighlightedTextField;
